(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var lenis = Object.freeze({
    start: function () {
      if (window.DuskloomMotion) window.DuskloomMotion.start();
    },
    stop: function () {
      if (window.DuskloomMotion) window.DuskloomMotion.stop();
    }
  });

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  function initHeader() {
    var hdr = document.querySelector('[data-header]');
    if (!hdr) return;

    function measure() {
      document.documentElement.style.setProperty('--hdr', hdr.offsetHeight + 'px');
    }
    measure();
    window.addEventListener('resize', measure, { passive: true });
    window.addEventListener('load', measure);

    var last = 0;
    function onScroll() {
      var y = window.scrollY;
      hdr.classList.toggle('is-stuck', y > 20);
      if (!document.body.classList.contains('nav-open')) {
        hdr.classList.toggle('is-hidden', y > 420 && y > last);
      }
      last = y;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var burger = document.querySelector('[data-burger]');
    if (burger) {
      burger.addEventListener('click', function () {
        var open = document.body.classList.toggle('nav-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.style.overflow = open ? 'hidden' : '';
        if (lenis) open ? lenis.stop() : lenis.start();
      });
      document.querySelectorAll('.mnav a').forEach(function (a) {
        a.addEventListener('click', function () {
          document.body.classList.remove('nav-open');
          document.body.style.overflow = '';
          burger.setAttribute('aria-expanded', 'false');
          if (lenis) lenis.start();
        });
      });
    }
  }

  function initReveals() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (REDUCED || !('IntersectionObserver' in window)) {
      els.forEach(function (n) {
        n.classList.add('is-in');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var node = e.target;
          node.style.transitionDelay = parseFloat(node.dataset.revealDelay || 0) + 's';
          node.classList.add('is-in');
          io.unobserve(node);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );
    els.forEach(function (n) {
      n.classList.add('is-reveal-pending');
      io.observe(n);
    });
  }

  function initAccordions() {
    document.querySelectorAll('[data-acc] .acc__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) {
          if (open) panel.removeAttribute('data-open');
          else panel.setAttribute('data-open', '');
        }
        if (window.DuskloomMotion) window.DuskloomMotion.refresh();
      });
    });
  }

  function initGallery() {
    var root = document.querySelector('[data-gallery]');
    if (!root) return;
    var main = root.querySelector('[data-gallery-main]');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!main || !btn.dataset.full) return;
        main.style.opacity = '0';
        setTimeout(function () {
          main.src = btn.dataset.full;
          main.alt = btn.dataset.alt || '';
          main.style.opacity = '1';
        }, 180);
        thumbs.forEach(function (b) {
          b.setAttribute('aria-current', b === btn ? 'true' : 'false');
        });
      });
    });
  }

  var Cart = {
    el: null,
    open: function () {
      if (!this.el) return;
      this.el.setAttribute('data-open', '');
      document.body.style.overflow = 'hidden';
      if (lenis) lenis.stop();
      var close = this.el.querySelector('[data-cart-close]');
      if (close) close.focus();
    },
    close: function () {
      if (!this.el) return;
      this.el.removeAttribute('data-open');
      document.body.style.overflow = '';
      if (lenis) lenis.start();
    },
    money: function (cents) {
      return '$' + (cents / 100).toFixed(2);
    },
    thumb: function (src) {
      return src.replace(/(\.[a-z]+)(\?|$)/i, '_160x200_crop_center$1$2');
    },
    render: function (cart) {
      var self = this;
      var body = this.el.querySelector('[data-cart-body]');
      var foot = this.el.querySelector('[data-cart-foot]');

      document.querySelectorAll('[data-cart-count]').forEach(function (c) {
        c.textContent = cart.item_count;
        c.hidden = cart.item_count === 0;
      });

      body.replaceChildren();

      if (!cart.items.length) {
        var empty = el('div', 'drawer__empty');
        empty.appendChild(el('p', null, 'Nothing here yet.'));
        var wrap = el('p');
        wrap.style.marginTop = '1rem';
        var a = el('a', 'tlink', 'See the lamps ');
        a.href = '/collections/all-lamps';
        a.appendChild(el('span', 'arw', '→'));
        wrap.appendChild(a);
        empty.appendChild(wrap);
        body.appendChild(empty);
        if (foot) foot.hidden = true;
        return;
      }
      if (foot) foot.hidden = false;

      cart.items.forEach(function (it) {
        var row = el('div', 'citem');
        if (it.image) {
          var img = el('img');
          img.src = self.thumb(it.image);
          img.alt = '';
          img.width = 72;
          img.height = 90;
          img.loading = 'lazy';
          row.appendChild(img);
        } else {
          var ph = el('div');
          ph.style.cssText = 'width:72px;height:90px;border-radius:9px;background:var(--ink-2)';
          row.appendChild(ph);
        }
        var col = el('div');
        col.appendChild(el('div', 'citem__name', it.product_title));
        col.appendChild(
          el('div', 'citem__meta', self.money(it.final_line_price) + ' · Qty ' + it.quantity)
        );
        var rm = el('button', 'citem__rm', 'Remove');
        rm.type = 'button';
        rm.addEventListener('click', function () {
          self.change(it.key, 0);
        });
        col.appendChild(rm);
        row.appendChild(col);
        body.appendChild(row);
      });

      var total = this.el.querySelector('[data-cart-total]');
      if (total) total.textContent = this.money(cart.total_price);
    },
    fetch: function () {
      var self = this;
      return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (c) {
          self.render(c);
          return c;
        });
    },
    change: function (key, qty) {
      var self = this;
      return fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (c) {
          self.render(c);
        });
    },
    add: function (form, btn) {
      var self = this;
      var label = btn ? btn.textContent : '';
      var err = form.querySelector('[data-form-error]');
      if (err) err.hidden = true;
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Adding…';
      }
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (res) {
          if (res.status && res.status !== 200) throw new Error(res.description || res.message);
          return self.fetch();
        })
        .then(function () {
          self.open();
        })
        .catch(function (e) {
          if (err) {
            err.textContent = e.message || 'Something went wrong. Please try again.';
            err.hidden = false;
          }
        })
        .finally(function () {
          if (btn) {
            btn.disabled = false;
            btn.textContent = label;
          }
        });
    }
  };

  function initCart() {
    Cart.el = document.querySelector('[data-cart-drawer]');
    if (!Cart.el) return;
    if (!window.Shopify) window.Shopify = {};
    if (!window.Shopify.routes) window.Shopify.routes = { root: '/' };

    document.querySelectorAll('[data-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        Cart.fetch().then(function () {
          Cart.open();
        });
      });
    });
    Cart.el.querySelectorAll('[data-cart-close]').forEach(function (b) {
      b.addEventListener('click', function () {
        Cart.close();
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && Cart.el.hasAttribute('data-open')) Cart.close();
    });

    document.querySelectorAll('[data-add-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        Cart.add(form, form.querySelector('[data-add-btn]'));
      });
    });

    Cart.fetch();
  }

  function boot() {
    initHeader();
    initReveals();
    initAccordions();
    initGallery();
    initCart();
    window.addEventListener('load', function () {
      if (window.DuskloomMotion) window.DuskloomMotion.refresh();
    }, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
